import ZonesList from './ZonesList'

export default ZonesList